import { z } from "zod/v4";

export const DeleteOrganizationAgencyLinkRequestBodySchema = z.object({
  agencyId: z.uuid(),
  orgId: z.uuid(),
  stripeSubscriptionIds: z.string().array(),
});

export type DeleteOrganizationAgencyLinkRequestBodyType = z.infer<
  typeof DeleteOrganizationAgencyLinkRequestBodySchema
>;

export const DeleteOrganizationAgencyLinkResponseBodySchema = z.string();

export type DeleteOrganizationAgencyLinkResponseBodyType = z.infer<
  typeof DeleteOrganizationAgencyLinkResponseBodySchema
>;
